import React, { useEffect, useState } from 'react'
// import Button from "../button";
import styles from './embassies_modal.module.css'
import { student } from '../../store/student'
import { report } from '../../store/report'
import http from '../../Service/http'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';

const ArchiveModal = ({ openForm, openSpravka }) => {
	const [modalData, setModalData] = useState([])
	const [groupData, setGroupData] = useState([])
	const [baseData, setBaseData] = useState([])
	const [isSave, setIsSave] = useState(false)
	const [refusal, setRefusal] = useState(false)
	const [groupName, setGroupName] = useState([]);
	const [osnovanieName, setOsnovanieName] = useState([]);
	const [updateNaz, setUpdateNaz] = useState({
		order_number: '',
		diploma_series: '',
		diploma_number: '',
		diploma_reg_number: '',
		qualification: '',
		application: '',
		with_honors: false
	})
	const [reasonRefusal, setReasonRefusal] = useState({
		rejected_komment: ''
	})

	const day_c_os = new Date().getDay()
	const month_c_os = new Date().getMonth() + 1;
	const year_c_os = new Date().getFullYear() 

	const day_po_os = new Date().getDay()
	const month_po_os = new Date().getMonth() + 1;
	const year_po_os = new Date().getFullYear()

	const [updateData, setUpdateData] = useState({
		date_of_the_decision_SAC: `${year_c_os}-${month_c_os}-${day_c_os}`,
		date_of_issue: `${year_po_os}-${month_po_os}-${day_po_os}`
	})


	const { t, i18n } = useTranslation()



	const openInput = () => {
		setRefusal(!refusal)
	}

	const ITEM_HEIGHT = 48;
	const ITEM_PADDING_TOP = 8;
	const MenuProps = {
	  PaperProps: {
		style: {
		  maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,			
		  width: 250,
		},
	  },
	};

	const getReports = async id => {
		const a = await http.post('/report/reportApplicationWait?reportType=' + id)
		report.newReport(a.data.reportApplicationWait)
	}

	const getModaldata = async () => {
		const res = await http.post('/okno/modaldata', {
			uid: student.student.id_student,
			gid: student.student.id_group,
			id_zakaz: student.student.id_okno_zakaz,
			doc: student.student.id_okno_document
		})
		setModalData(res.data.data)
		setUpdateNaz({ 
			order_number: res.data.data.order_number, 
			diploma_series: res.data.data.diploma_series, 
			diploma_number: res.data.data.diploma_number, 
			diploma_reg_number: res.data.data.diploma_reg_number, 
			qualification: res.data.data.qualification, 
			application: res.data.data.application, 
			with_honors: res.data.data.with_honors, 
		})
		let arr=res.data.data.groups.split(",").map(Number)
		setGroupName(arr)
		setOsnovanieName(res.data.data.osnovanii.split(",").map(Number))
		setUpdateData({date_of_the_decision_SAC:dayjs(res.data.data.date_of_the_decision_SAC).format("YYYY-MM-DD"),
			date_of_issue:dayjs(res.data.data.date_of_issue).format("YYYY-MM-DD")})
	}

	const getArchiveModaldata = async () => {
		const res = await http.post('/okno/archiveModaldata', {
			uid: student.student.id_student,
			gid: student.student.id_group,
			id_zakaz: student.student.id_okno_zakaz,
			doc: student.student.id_okno_document
		})
		setGroupData(res.data.data[0])
		setBaseData(res.data.data[1])
	}
	console.log('groupData', groupData)
	console.log('baseData', baseData)
	
	// процедура на модального окно для сохранения данных в справках
	const updateModalDate = async () => {
		const date_of_the_decision_SAC = dayjs(updateData.date_of_the_decision_SAC).format('YYYY-MM-DD HH:mm:ss')
		// console.log("date_c",date_c)
		const date_of_issue = dayjs(updateData.date_of_issue).format('YYYY-MM-DD HH:mm:ss')
		// console.log("datepo",date_po)

		const res = await http.post('/okno/modalDateUpdate', {
			id_zakaz: student.student.id_okno_zakaz,
			uid: student.student.id_student,
			gid: student.student.id_group,
			doc: student.student.id_okno_document,
			groups: groupName,
			osnovanii: osnovanieName,
			order_number: updateNaz.order_number,
			diploma_series: updateNaz.diploma_series,
			diploma_number: updateNaz.diploma_number,
			diploma_reg_number: updateNaz.diploma_reg_number,
			qualification: updateNaz.qualification,
			application: updateNaz.application,
			with_honors: updateNaz.with_honors,
			date_of_the_decision_SAC: date_of_the_decision_SAC,
			date_of_issue: date_of_issue,
			raion_kg: null,
			work: null
		})
		if (res.data.result !== null) {
			toast(res.data.result)
		}
		setIsSave(false)
		// console.log("update Embass", res);
	}


	const postReasonRefusal = async () => {
		const res = await http.post('/okno/reasonRefusal', {
			id_zakaz: student.student.id_okno_zakaz,
			doc: student.student.id_okno_document,
			rejected_komment: reasonRefusal.rejected_komment
		})
		if (res.data.result == null) {
			toast(res.data.result)
			getReports(0)
			openForm()
			// setIsSave(false)
		}
		// console.log("update", res);
	}

	React.useEffect(() => {
		document.body.style.overflowY = 'hidden'
		return () => (document.body.style.overflowY = 'visible')
	}, [])

	React.useEffect(() => {
		getReports(0)
	}, [])

	React.useEffect(() => {
		if (openForm) {
			getModaldata()
			getArchiveModaldata()
		}
	}, [])

	const change = e => {
		const { name, value } = e.target
		setUpdateNaz({ ...updateNaz, [name]: value })
		console.log(':nameval', { [name]: value })
		setIsSave(true)
		console.log('issave', isSave)
	}

	const changeCheck = e => {
		setUpdateNaz({
			...updateNaz,
			[e.target.name]: e.target.checked
		})
		setIsSave(true)
	}

	const onChangeDate = e => {
		setUpdateData({
			...updateData,
			[e.target.name]: e.target.name == 'with_honors' ? e.target.checked : e.target.value
		})
		setIsSave(true)
	}

	  const changeGroupData = (event) => {
		const {
		  target: { value: selectedIds },
		} = event;
		// console.log("value", selectedIds);
		setIsSave(true)
		setGroupName(selectedIds);
	  };
	
	  const handleChange = (event) => {
		const { value } = event.target;
		setOsnovanieName(value)
		setIsSave(true)
	  };


	const changeRefusal = e => {
		const { name, value } = e.target
		setReasonRefusal({ ...reasonRefusal, [name]: value })
		console.log(':reasonRefusal', { [name]: value })
	}
	
	
	return (
		<div className={styles.modal}>
			<div className={styles.modal_window}>
				<div className={styles.modal_window_head}>
					<div></div>
					<label>{modalData.okno_document}</label>
					{!refusal ? (
						<div className={styles.add_form_stud_exit}>
							{updateNaz.qualification?.length >= 4 ? (
								<a
									className='new_report'
									target='_blank'
									href={`/bt/api/r/a-e?idzakaz=${student.student.id_okno_zakaz}&idf=${student.student.id_faculty}&gid=${student.student.id_group}&id=${student.student.id_student}&lang=${i18n.language}`}
								>
									<button className={styles.button_modal} onClick={openForm}>
										Просмотр
									</button>
								</a>
							) : null} 
						</div>
					) : (
						<div></div>
					)}
				</div>
				
				{!refusal ? (
					<div>
						<div className={styles.name_student}>
							<div className={styles.name_student_block}>
								<span className={styles.name_student_text}>Студент:</span>
								<p>{modalData?.fio}</p>
							</div>
							<div className={styles.name_student_block}>
								<span className={styles.name_student_text}>Уникальный номер справки:</span>
								<p>{modalData.reference_number}</p>
							</div>
						</div>
						<div className={styles.modal_window_data}>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Группа:</span>
								<FormControl sx={{ width: 370 }}>
									<InputLabel id="demo-multiple-checkbox-label" style={{marginTop: '-10px'}}>Выбрать группу</InputLabel>
									<Select 
										style={{border: "1px solid #02a4ea"}}
										sx={{ height: 30 }}
										labelId="demo-multiple-checkbox-label"
										id="demo-multiple-checkbox"
										multiple
										value={groupName}
										onChange={changeGroupData}
										input={<OutlinedInput label="Tag" />}
										renderValue={(selected) =>
											groupData
											  .filter((name) => selected.includes(name.id_group))
											  .map((filteredName) => filteredName.p20)
											  .join(", ")
										  }
										  MenuProps={MenuProps}
										>
										{groupData?.map((name) => (
											<MenuItem key={name.id_group} value={name?.id_group} style={{zIndex: '9999999'}}>
											<Checkbox checked={groupName.includes(name.id_group)}/>
											<ListItemText primary={name?.p20} />
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</div>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Основание:</span>
								<FormControl sx={{ width: 370 }}>
									<InputLabel id="demo-multiple-checkbox-label" style={{marginTop: '-10px'}}>Выбрать основание.</InputLabel>
									<Select 
										style={{border: "1px solid #02a4ea"}}
										sx={{ height: 30 }}
										labelId="demo-multiple-checkbox-label"
										id="demo-multiple-checkbox"
										multiple
										value={osnovanieName}
										onChange={handleChange}
										input={<OutlinedInput label="Tag" />}
										renderValue={(selected) =>
											baseData
											  .filter((base) => selected.includes(base.id_okno_osnovanie))
											  .map((filteredName) => filteredName.osnovanie)
											  .join(", ")
										  }
										MenuProps={MenuProps}
										>
										{baseData?.map((name) => (
											<MenuItem key={name?.id_okno_osnovanie} value={name?.id_okno_osnovanie} style={{zIndex: '9999999'}}>
											<Checkbox checked={osnovanieName.includes(name?.id_okno_osnovanie)}/>
											<ListItemText primary={name?.osnovanie} />
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</div>

							<div className={styles.input_block}>
								<div className={styles.new_input_block_date}>
									<span className={styles.name_student_text}>№ приказа:</span>
									<input
										onChange={change}
										className={styles.input_modal_date}
										type='text'
										placeholder='номер приказа'
										name='order_number'
										value={updateNaz.order_number}
									/>
								</div>
								<div className={styles.new_input_block_date2}>
									<span className={styles.name_student_text}>Дата решения ГАК:</span>
									<input
										onChange={onChangeDate}
										className={styles.input_modal_date}
										type='date'
										placeholder='YYYY'
										name='date_of_the_decision_SAC'
										value={updateData.date_of_the_decision_SAC}
									/>
								</div>
							</div>
							<div className={styles.input_block}>
									<div className={styles.new_input_block_date}>
										<span className={styles.name_student_text}>Серия диплома:</span>
										<input
											onChange={change}
											className={styles.input_modal_date}
											type='text'
											placeholder='серия диплома'
											name='diploma_series'
											value={updateNaz.diploma_series}
										/>
									</div>
									<div className={styles.new_input_block_date2}>
										<span className={styles.name_student_text}>Номер диплома:</span>
										<input
											onChange={change}
											className={styles.input_modal_date}
											type='text'
											placeholder='номер диплома'
											name='diploma_number'
											value={updateNaz.diploma_number}
										/>
									</div>
							</div>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Приложение: (количество листов)</span>
								<input
									className={styles.input_modal}
									type='number'
									name='application'
									value={updateNaz.application}
									onChange={change}
								>
								</input>
							</div>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Регистрационный номер диплома:</span>
								<input
									className={styles.input_modal}
									type='text'
									name='diploma_reg_number'
									value={updateNaz.diploma_reg_number}
									onChange={change}
								>
								</input>
							</div>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Квалификация:</span>
								<input
									className={styles.input_modal}
									onChange={change}
									type='text'
									name='qualification'
									value={updateNaz.qualification}
								>
								</input>
							</div>
							<div className={styles.input_block}>
									<div className={styles.new_input_block_date}>
										<span className={styles.name_student_text}>С отличием/без:</span>
										<input
											onChange={changeCheck}
											className={styles.input_modal_checkbox}
											type='checkbox'
											name='with_honors'
											checked={updateNaz.with_honors}
										/>
									</div>
									<div className={styles.new_input_block_date2}>
										<span className={styles.name_student_text}>Дата выдачи:</span>
										<input
											onChange={onChangeDate}
											className={styles.input_modal_date}
											type='date'
											placeholder='YYYY'
											name='date_of_issue'
											value={updateData.date_of_issue}
										/>
									</div>
							</div>
						</div>

						<div className={styles.user}>
							<div className={styles.user_name}>
								<span className={styles.name_student_text}>Исполнитель:</span>
								<p>{modalData.AVN_operator}</p>
							</div>
						</div>
					</div>
				) : (
					<div className={styles.modal_window_data}>
						<div className={styles.input_block}>
							<span className={styles.name_student_text}>Причина отказа:</span>
							<input
								className={styles.input_modal}
								type='text'
								placeholder='Введите причину отказа...'
								name='rejected_komment'
								value={reasonRefusal.rejected_komment}
								onChange={changeRefusal}
							>
								{/* Причина отказа */}
							</input>
						</div>
					</div>
				)}

				<div className={styles.modal_footer}>
					<div></div>
					<div className={styles.footer_buttons}>
						{refusal ? (
							<>
								{reasonRefusal.rejected_komment?.length >= 4 ? (
									<button onClick={postReasonRefusal} className={styles.button_modal}>
										Отказать
									</button>
								) : (
									<button
										className={styles.button_modal}
										style={{ background: '#c8c8c8' }}
										disabled
										onClick={postReasonRefusal}
									>
										Отказать
									</button>
								)}
								<button onClick={openInput} className={styles.button_modal}>
									Назад
								</button>
							</>
						) : (
							<>
								<button onClick={openInput} className={styles.button_modal}>
									Отказать
								</button>
								{updateNaz.qualification?.length >= 3 && isSave ? (
									<button className={styles.button_modal} onClick={updateModalDate}>
										Сохранить
									</button>
								) : (
									<button
										className={styles.button_modal}
										style={{ background: '#c8c8c8' }}
										disabled
										onClick={updateModalDate}
									>
										Сохранить
									</button>
								)}
								<button onClick={openForm} className={styles.button_modal}>
									Закрыть
								</button>
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}

export default ArchiveModal
